import { User } from '@app/user-management/types/user'

function startOfDay(date: Date): Date {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate())
}

function isValidCalendarDate(year: number, month: number, day: number): boolean {
  if (month < 1 || month > 12 || day < 1) {
    return false
  }

  const date = new Date(year, month - 1, day)
  return date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day
}

function parseExpirationDate(value: string): Date | null {
  const match = /^(\d{4})-(\d{2})-(\d{2})(?:$|T)/.exec(value)
  if (!match) {
    return null
  }

  const year = Number(match[1])
  const month = Number(match[2])
  const day = Number(match[3])

  if (!isValidCalendarDate(year, month, day)) {
    return null
  }

  return new Date(year, month - 1, day)
}

/**
 * Returns true when the user is on an active pilot: `pilot` is true and
 * `pilotMetaData.expirationDate` is after today's date.
 */
export function isActivePilot(user: User, referenceDate: Date = new Date()): boolean {
  if (!user.pilot) {
    return false
  }

  const expirationDate = user.pilotMetaData?.expirationDate
  if (!expirationDate) {
    return false
  }

  const expiration = parseExpirationDate(expirationDate)
  if (!expiration) {
    return false
  }

  return startOfDay(expiration) > startOfDay(referenceDate)
}
